/**
 * Created by admin on 2018/5/14.
 */
export { default as DeptUserManage } from './DeptUserManage/DeptUserManage';
export { default as RoleManage } from './RoleManage';
export { default as BoardManage } from './BoardManage';
export { default as RoomManage } from './RoomManage';
export { default as DeviceManage } from './DeviceManage';
export { default as ServiceManage } from './ServiceManage';
export { default as SupportManage } from './SupportManage';
export { default as PortManage } from './PortManage';
export { default as LogManage } from './LogManage';
export { default as WorkdayManage } from './WorkdayManage';
export { default as VideoManage } from './VideoManage';
export { default as NoticeManage } from './NoticeManage';
export { default as PolicyManage } from './PolicyManage';
export { default as LicensePage}  from './LicensePage';



// WEBPACK FOOTER //
// ./src/routes/SystemConfig/index.js